import React, { useRef, useState } from 'react';
import type { ColDef } from 'ag-grid-community';
import HLPageTable, {
    HLPageTableFilterConfig,
    HLPageTableRef,
    HLPageTableRowActionButton
} from '../../shared/components/table/HLPageTable';
import { ConfigurationType, ConfigurationTypeNameMap, ConfigurationView, } from '../../shared/types/configuration';
import { getAllConfigurationsFetch } from '../../app/axios/configurationFetches';
import UpdateConfigurationModal from '../../modal/configuration/UpdateConfigurationModal';
import { formatDateTimeForString } from '../../shared/utils/dateUtils';
import { formatConfigurationValue } from "../../shared/utils/configurationUtils";

const searchFiltersConfig: HLPageTableFilterConfig<ConfigurationView>[] = [
    {
        fieldName: 'name',
        label: 'Имя',
        operator: 'like',
        type: 'input'
    },
    {
        fieldName: 'description',
        label: 'Описание',
        operator: 'like',
        type: 'input'
    },
    {
        fieldName: 'type',
        label: 'Тип',
        operator: '=',
        type: 'select',
        options: Object.entries(ConfigurationTypeNameMap).map(([value, label]) => ({
            value,
            label
        }))
    }
]

const columnDefs: ColDef<ConfigurationView>[] = [
    {
        field: 'name',
        headerName: 'Имя',
    },
    {
        field: 'description',
        headerName: 'Описание',
    },
    {
        field: 'type',
        headerName: 'Тип',
        valueFormatter: params => ConfigurationTypeNameMap[params.value as ConfigurationType],
    },
    {
        field: 'value',
        headerName: 'Значение',
        valueFormatter: params => params.data ? formatConfigurationValue(params.data) : '-',
    },
    {
        field: 'updatedByLogin',
        headerName: 'Кто изменил',
    },
    {
        field: 'updatedAt',
        headerName: 'Когда изменили',
        valueFormatter: params => params.value ? formatDateTimeForString(params.value) : '-',
    }
]

const defaultColDef: ColDef<ConfigurationView> = {
    sortable: false,
    filter: false,
    resizable: true,
    flex: 1,
    minWidth: 100
}

const ConfigurationsPage: React.FC = () => {
    const tableRef = useRef<HLPageTableRef>(null)
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false)
    const [selectedConfiguration, setSelectedConfiguration] = useState<ConfigurationView | null>(null)

    const handleSuccess = () => {
        setSelectedConfiguration(null)
        setIsUpdateModalOpen(false)
        tableRef.current?.refreshData()
    }

    const rowActionButtons: HLPageTableRowActionButton[] = [
        {
            getLabel: () => 'Изменить',
            onClick: params => {
                if (params?.data) {
                    setSelectedConfiguration(params.data)
                    setIsUpdateModalOpen(true)
                }
            }
        }
    ]

    return (
        <>
            <HLPageTable
                ref={tableRef}
                title="Конфигурации"
                columns={columnDefs}
                defaultColDef={defaultColDef}
                filterConfig={searchFiltersConfig}
                actionButtons={[]}
                fetchData={getAllConfigurationsFetch}
                rowActionButtons={rowActionButtons}
                height={window.innerHeight}
            />
            <UpdateConfigurationModal
                open={isUpdateModalOpen}
                setOpen={setIsUpdateModalOpen}
                configuration={selectedConfiguration}
                onSuccess={handleSuccess}
            />
        </>
    )
}

export default ConfigurationsPage
